import {
  FormControlLabel,
  Switch,
  SwitchProps,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface MuiSwitchControlledProps extends SwitchProps {
  switchProps: {
    name: string;
    defaultValue?: boolean;
    label?: string;
  };
}

export function MuiSwitchControlled({
  switchProps,
  ...rest
}: MuiSwitchControlledProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={switchProps.name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={<Switch {...field} {...rest} checked={field.value} />}
          label={
            <Typography sx={{ fontSize: '14px', color: '#101828' }}>
              {switchProps.label}
            </Typography>
          }
        />
      )}
    />
  );
}
